import { v4 } from 'uuid'

const STORAGE_KEY = 'anonymous-user-id'

export const getAnonymousUserId = () => {
  if (typeof window === 'undefined') {
    return undefined
  }

  const value = window.localStorage.getItem(STORAGE_KEY)

  if (value === null) {
    const newUserId = v4()
    window.localStorage.setItem(STORAGE_KEY, newUserId)
    return newUserId
  }

  return value
}

export const setAnonymousUserId = (anonymousUserId: string) => {
  if (typeof window === 'undefined') {
    return
  }

  window.localStorage.setItem(STORAGE_KEY, anonymousUserId)
}
